import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  drugs: [],
  loading: false,
  search: '',
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    setCatalogLoading(state, action) {
      state.loading = action.payload;
    },
    loadCatalog(state, action) {
      state.drugs = action.payload.drugs;
      state.loading = false;
    },
    updateCatalogSearch(state, action) {
      state.search = action.payload.search;
    },
  },
});

export const catalogActions = catalogSlice.actions;
export default catalogSlice.reducer;
